/**
 * Format Post Timestamp to Relative Time
 * Converts a timestamp to a human-readable relative time string.
 * Examples: "Just now", "5m ago", "2h ago", "3d ago", or full date for older posts.
 */

/**
 * Format a date to a relative time string
 * @param {string|Date} date - The date to format
 * @returns {string} A human-readable relative time string
 */
export function formatPostTimestampToRelative(date) {
  const d = new Date(date);
  const now = new Date();
  const diff = now - d;
  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (minutes < 1) return 'Just now';
  if (minutes < 60) return `${minutes}m ago`;
  if (hours < 24) return `${hours}h ago`;
  if (days < 7) return `${days}d ago`;
  return d.toLocaleDateString();
}

export default formatPostTimestampToRelative;
